module.exports = __webpack_public_path__ + "img/icon_numbers_of_account_hover.bdcf96cb.svg";